import React, { Component } from "react";
import { Route, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withLDProvider } from 'ldclient-react';
import env from "../../utils/env";

import { setViewWidth } from "modules/view";
import MyBoxPage from "../MyBoxPage/MyBoxPage";

import "./App.css";

let fffuser = window.fffuser
  ? window.fffuser
  : { useremail: "prospect@fabfitfun.com" };
let LDUser =  {
  "key": fffuser.useremail,
  "username": fffuser.useremail,
  "email": fffuser.useremail
};

class App extends Component {
  componentWillMount() {
    window.addEventListener("resize", this.handleResize);
  }

  handleResize = () => this.props.setViewWidth(window.innerWidth);

  render() {
    return (
      <div>
        <main className="my-box-page">
          <Route path="*" component={MyBoxPage} />
        </main>
      </div>
    );
  }
}

const mS = (state, ownProps) => ({
  isMobile: state.view.isMobile
});

const mD = dispatch =>
  bindActionCreators(
    {
      setViewWidth
    },
    dispatch
  );

export default withRouter(
  connect(
    mS,
    mD
  )(withLDProvider({
      clientSideID: env.ldKey,   
      user: LDUser
    }
  )(App))
)



// WEBPACK FOOTER //
// ./src/Components/App/App.js